import React, { useEffect, /*useRef,*/ useState } from "react";
import { useAppSelector, useAppDispatch } from "../../../../store/hooks";
import { KonvaEventObject } from "konva/lib/Node";
import {
  addItemToSelection,
  exitSelection,
  insertingSnappingPoint,
  removeSnappingPoint,
  replaceShape,
} from "../../../../store/model";
import { getPointerModelPosition } from "../../util/stageManipulation";
import Hotspot from "../../Hotspot";
import {
  cross,
  distance2d,
  distancePointFromLine,
  inBetweenPoints,
  //lineLineIntersectionFromSegments,
  lineRectIntersection,
  //segmentRectIntersection,
  //segmentSegmentIntersection,
} from "../../../../geometry/operation";
import { Transform } from "../../../../geometry/transformation";
import { createPolygonRubber } from "../../tools/PolygonRubber";
import BasePolygon from "./PolygonBase";
import { JSONGeometricShape } from "../../../Palettes/Headerbar/toolbarButtonOpen";
import { recalculateShape, transformShape } from "../../util/shapeEdit";
import { setMouseUnmodifiedPosition } from "../../../../store/interface";
import { endRubberline, interactionAddEditingReferencePoint } from "../../../../store/interaction";
//import Konva from "konva";
import ClickableHotspot from "../../ClickableHotspot";
import _ from "lodash";

interface PolygonProps {
    shapeProps: PolygonShape;
    onSelect: (e: KonvaEventObject<MouseEvent>) => void;
}

const Polygon = ({ shapeProps, onSelect }: PolygonProps) => {
  // Initialize Transformation
  const shapeTransformation = shapeProps.transformation;
  const [localHotspotDiff, setLocalHotspotDiff] = useState<Point2d[]>(
    new Array<Point2d>(shapeProps.points.length).fill({ x: 0, y: 0 })
  );
  const [localTransform, setLocalTransform] =
    useState<Mat5>(Transform.mat5Identity);
  const [polygonPoints, setPolygonPoints] = useState<Hotspot[]>(
    initHotspot(shapeProps.points)
  );
//   const [trafoedHSPointslocal, setTrafoedHSPointslocal] = useState<Hotspot[]>(
//     initHotspot(shapeProps.points)
//   );
//   const [clickTime, setClickTime] = useState<number>();

  const dispatch = useAppDispatch();
  const selection = useAppSelector((state) => state.model.present.selected);
  const selected = selection.selectedItemIds.includes(shapeProps.id);
  const currentTool = useAppSelector((state) => state.tool.currentTool);
 // const toolSettings = useAppSelector((state) => state.tool.toolSettings);
  const scale = useAppSelector((state) => state.interface.viewport.scale);
  const snapPosition = useAppSelector((state) => state.interface.mousePositionSnap);
//   let konvaLineRef = useRef<Konva.Line | null>(null);
  const [dragStartPosition, setDragStartPosition] = useState<Point2d>({ x: 0, y: 0, });
  const [hsDragStartPoint, setHsDragStartPoint] = useState<Point2d>({ x: 0, y: 0, });
  //const [selectedHotspot/*, setSelectedHotspot*/] = useState<Hotspot>();
  // const [clickedOn, setClickedOn] = useState<boolean>(false);
  let shapeTransformer = new Transform(shapeTransformation);
  //const inverseTransform = new Transform(shapeProps.transformation).invert2d()


  useEffect(() => {
    const points = shapeProps.points.length ? shapeProps.points.map((point, i): Hotspot => {
      return {
        ...point,
        x: shapeProps.points[i].x,
        y: shapeProps.points[i].y,
        id: i.toString(),
        isDragging: false,
      };
    }) : []
    if (points?.length > 0) {
        if (points.length < 2 || points[points.length - 1].x !== points[0].x || points[points.length - 1].y !== points[0].y)
        points[points.length] = _.cloneDeep(points[0]);
    }
    setPolygonPoints(points)
  }, [shapeProps.points])

  function initHotspot(points: Point2d[]): Hotspot[] {
    if (!points) return [];
    else {
      const hotpsotList = points.map((v, i): Hotspot => {
        return {
          ...v, // apply trafo
          x: shapeProps.points[i].x,
          y: shapeProps.points[i].y,
          id: i.toString(),
          isDragging: false,
        };
      });
      return hotpsotList;
    }
  }

  function setHighlightPoint(id: string, state: boolean = true) {
    let newPoints = polygonPoints.map((spot: Hotspot, i) => {
        return {
          ...spot,
          isDragging: state ? i.toString() === id : false,
        };
      });
    if (newPoints?.length > 0) {
        if (newPoints.length < 2 || newPoints[newPoints.length - 1].x !== newPoints[0].x || newPoints[newPoints.length - 1].y !== newPoints[0].y)
        newPoints[newPoints.length] = _.cloneDeep(newPoints[0]);
    }
    setPolygonPoints(
      newPoints
    );
  }

  const handleHotspotDragMove = (e: KonvaEventObject<MouseEvent>) => {
    const id = Number.parseInt(e.target.id());

    const mousePosition = getPointerModelPosition(e)
    dispatch(setMouseUnmodifiedPosition(mousePosition))
    console.log("snapPosition", snapPosition);
    const pos = snapPosition ?? { x: mousePosition.x, y: mousePosition.y }
    let newLocalHotspotDiff = localHotspotDiff;
    let pointToChange = newLocalHotspotDiff[id];

    // Inverse the mouse movement and store it in localHotpsotDiff
    const inverseTransformer = shapeTransformer.copy().invert2d();
    const invertedStartPoint = hsDragStartPoint;
    const invertedEndPoint = inverseTransformer.point2d(pos);
    const invertedMouseMovementVector = {
      x: invertedEndPoint.x - invertedStartPoint.x,
      y: invertedEndPoint.y - invertedStartPoint.y,
    };
    newLocalHotspotDiff[id] = {
      ...pointToChange,
      x: invertedMouseMovementVector.x,
      y: invertedMouseMovementVector.y,
    };

    if (id === 0) {
      newLocalHotspotDiff[newLocalHotspotDiff.length - 1].x = invertedMouseMovementVector.x;
      newLocalHotspotDiff[newLocalHotspotDiff.length - 1].y = invertedMouseMovementVector.y;
    }
    if (id === newLocalHotspotDiff.length - 1) {
      newLocalHotspotDiff[0].x = invertedMouseMovementVector.x;
      newLocalHotspotDiff[0].y = invertedMouseMovementVector.y;
    }

    setLocalHotspotDiff(newLocalHotspotDiff);

    // Set Polygon Position what is used for final polygon render
    console.log("setting")
    let newPoints = shapeProps.points.map((spot, i) => {
        return {
          id: i.toString(),
          x: spot.x + localHotspotDiff[i].x,
          y: spot.y + localHotspotDiff[i].y,
          isDragging: false,
        };
      });
    if (newPoints?.length > 0) {
        if (newPoints.length < 2 || newPoints[newPoints.length - 1].x !== newPoints[0].x || newPoints[newPoints.length - 1].y !== newPoints[0].y)
        newPoints[newPoints.length] = _.cloneDeep(newPoints[0]);
    }
    setPolygonPoints(
      newPoints
    );
  };

  const handleHotspotDragStart = (e: KonvaEventObject<MouseEvent>) => {
    const id = Number.parseInt(e.target.id())
    const pointPosi = polygonPoints[id]
    const nearestPoint = chooseNearestPoint(polygonPoints[id - 1], polygonPoints[id + 1], pointPosi)
    dispatch(interactionAddEditingReferencePoint(shapeTransformer.point2d(nearestPoint)))
    dispatch(removeSnappingPoint({ id: shapeProps.id, pointId: id }))
    setHsDragStartPoint(pointPosi);
    setHighlightPoint(e.target.id());
  };


  const handleHotspotDragEnd = (e: KonvaEventObject<MouseEvent>) => {
    const id = Number.parseInt(e.target.id());
    dispatch(endRubberline())
    dispatch(interactionAddEditingReferencePoint(undefined))
    console.log(shapeProps.points, hsDragStartPoint);

    dispatch(insertingSnappingPoint({ id: shapeProps.id, pointId: id, point: hsDragStartPoint }))

    // Delete point if its near a neighbor
    const pointsAfterDeletion = e.evt.shiftKey
      ? polygonPoints
      : deletePoint(polygonPoints, id, polygonPoints[id], scale);

    setPolygonPoints(
      pointsAfterDeletion.map((h) => {
        return { ...h, isDragging: false };
      })
    );

    const payload: PolygonShape = {
      ...shapeProps,
      points: pointsAfterDeletion.map((h) => {
        return { x: h.x, y: h.y };
      }),
    };
    dispatch(
      replaceShape({
        // ...payload,
        ...transformShape(payload),
        snapPoint: calculatePolygonSnapPoints(payload).snapPoint,
      })
    );
    setLocalHotspotDiff(
      polygonPoints.map(() => {
        return { x: 0, y: 0 };
      })
    );
  };

  const onPolygonDragStart = (e: KonvaEventObject<MouseEvent>) => {
    const id = e.target.id();
    dispatch(exitSelection());
    dispatch(addItemToSelection(parseInt(id)));
    setDragStartPosition(getPointerModelPosition(e));
  };

  const handlePolygonDragMove = (e: KonvaEventObject<MouseEvent>) => {
    const pointerPos = getPointerModelPosition(e);
    const move: Point2d = {
      x: pointerPos.x - dragStartPosition.x,
      y: pointerPos.y - dragStartPosition.y,
    };
    const newTransform = Transform.translationTransform(move.x, move.y);
    setLocalTransform(newTransform.m);
  };

  const onPolygonDragEnd = (e: KonvaEventObject<MouseEvent>) => {
    moveObject();
    setLocalTransform([
      [1, 0, 0, 0],
      [0, 1, 0, 0],
      [0, 0, 1, 0],
      [0, 0, 0, 1],
    ]);
  };

  const moveObject = () => {
    const newTransform = shapeTransformer.m;
    const payload: PolygonShape = {
      // trafo = trafo * movetrafo
      ...shapeProps,
      transformation: newTransform,
    };

    dispatch(
      replaceShape({
        ...payload,
        snapPoint: calculatePolygonSnapPoints(payload).snapPoint,
      })
    );
  };

  // Mouse Interactions
  const movePolygon: MouseInteraction = {
    handleDragStart: onPolygonDragStart,
    handleDragMove: handlePolygonDragMove,
    handleDragEnd: onPolygonDragEnd,
  };

  function findNearestSegment(hotspots: Hotspot[], point: Point2d): number {
    const index = hotspots.map((spot, i, hotspots) => {
      if (i < hotspots.length - 1) {
        if (inBetweenPoints(hotspots[i], hotspots[i + 1], point, 10)) {
          const polygonFromPoints = cross(
            { ...hotspots[i], w: 1 },
            { ...hotspots[i + 1], w: 1 }
          );
          return {
            index: i,
            distance: distancePointFromLine(point, {
              a: polygonFromPoints.x,
              b: polygonFromPoints.y,
              c: polygonFromPoints.w,
            }),
          };
        }
      }
      return undefined;
    });

    interface PointWithDistance {
      index: number;
      distance: number;
    }
    type pointDistance = Required<PointWithDistance>;
    const filteredPoints = index.filter(
      (a): a is pointDistance => !!a?.distance
    );

    if (!filteredPoints.length) {
      console.error(
        "There is no element in Distance Array, click is on invalid position?"
      );
      return -1;
    }
    const initial = filteredPoints[0];
    return filteredPoints.reduce(
      (prev, curr) => (prev.distance > curr.distance ? curr : prev),
      initial
    ).index;
  }

  const findInversePosition = (pos: Point2d) => {
    const inverseTransformer = shapeTransformer.copy().invert2d();
    return inverseTransformer.point2d(pos);
  };

  const [nearestIndex, setNearestIndex] = useState<number>(-1);
  const addPoint: MouseInteraction = {

    handleClick(e: KonvaEventObject<MouseEvent>) {

      const indexNearest = findNearestSegment(
        polygonPoints,
        findInversePosition(getPointerModelPosition(e))
      );
      setNearestIndex(indexNearest);
      const pos = findInversePosition(getPointerModelPosition(e));
      if (indexNearest >= 0) {
        // Insert new pointer position to the pointlist.
        const newPoints = polygonPoints.slice(0, indexNearest + 1).concat(
          {
            ...pos,
            id: indexNearest.toString(),
            isDragging: false,
          },
          // Increment ID of the rest
          polygonPoints.slice(indexNearest + 1, polygonPoints.length)
        );
        while (newPoints.length > 0) {

        }
        setPolygonPoints(newPoints);
        const payload: PolygonShape = {
          ...shapeProps,
          points: newPoints,
        };
        dispatch(
          replaceShape(recalculateShape(payload))
        );
        setLocalHotspotDiff(
          newPoints.map(() => {
            return { x: 0, y: 0 };
          })
        );
      }
    },
    handleDragStart: (e: KonvaEventObject<MouseEvent>): void => {
      const indexNearest = findNearestSegment(
        polygonPoints,
        findInversePosition(getPointerModelPosition(e))
      );
      setNearestIndex(indexNearest);
      const pos = findInversePosition(getPointerModelPosition(e));
      if (indexNearest >= 0) {
        // Insert new pointer position to the pointlist.
        const newPoints = polygonPoints.slice(0, indexNearest + 1).concat(
          {
            ...pos,
            id: indexNearest.toString(),
            isDragging: false,
          },
          // Increment ID of the rest
          polygonPoints.slice(indexNearest + 1, polygonPoints.length)
        );
        setPolygonPoints(newPoints);
      }
    },

    handleDragMove: (e: KonvaEventObject<MouseEvent>): void => {
      e.target.position({ x: 0, y: 0 }); //Its ugly, but drag sets position
      const currentPointIndex = nearestIndex + 1;

      const pos = findInversePosition(getPointerModelPosition(e));
      setPolygonPoints(
        polygonPoints.map((spotItem, i) => {
          if (i === currentPointIndex) {
            return {
              ...spotItem,
              x: pos.x,
              y: pos.y,
              isDragging: currentPointIndex === i,
            };
          }
          return spotItem;
        })
      );
    },
    handleDragEnd: (e: KonvaEventObject<MouseEvent>): void => {
      const payload: PolygonShape = {
        ...shapeProps,
        points: polygonPoints.map((h: Hotspot) => {
          return { x: h.x, y: h.y };
        }),
      };
      dispatch(
        replaceShape({
          ...payload,
          snapPoint: calculatePolygonSnapPoints(payload).snapPoint,
        })
      );
      setLocalHotspotDiff(
        polygonPoints.map(() => {
          return { x: 0, y: 0 };
        })
      );
    },
  };
  // EditingModes set in Map //TODO ref? editing modestorage
  const mouseInteractionMap = new Map<EditType, MouseInteraction>();
  mouseInteractionMap.set("addPoint", addPoint);
  mouseInteractionMap.set("move", movePolygon);

  shapeTransformer.multiply(new Transform(localTransform));


  const trafoedHSPoints = polygonPoints.map((coordiante, i) => {
    const c = shapeTransformer.point2d(
      /*selectedHotspot && i === parseInt(selectedHotspot.id)
        ? { ...coordiante, ...inverseTransform.point2d({ x: snapPosition?.x ?? 0, y: snapPosition?.y ?? 0 }) }
        :*/ coordiante);
    return { ...coordiante, x: c.x, y: c.y };
  });

  //TODOChoose Current editing mode:
//   const editingMode =
//     selection.selectedItemIds.length === 1
//       ? toolSettings.line.currentEditMode
//       : toolSettings[currentTool].currentEditMode;

  //const currentMouseInteraction = mouseInteractionMap.get(editingMode);


//   const mouseClickMovePointInteraction = {
//     clickStart: (hs: Hotspot) => {
//       //console.log("click", selectedHotspot)
//       setClickTime(Date.now());
//       if (selectedHotspot === undefined) {
//         const id = Number.parseInt(hs.id)
//         const pointPosi = polygonPoints[id]
//         const nearestPoint = chooseNearestPoint(polygonPoints[id - 1], polygonPoints[id + 1], pointPosi)
//         dispatch(interactionAddEditingReferencePoint(shapeTransformer.point2d(nearestPoint)))
//         hs.isDragging = true;
//         setSelectedHotspot(hs);
//         setTrafoedHSPointslocal(polygonPoints);
//       }
//     },
//     clickEnd: () => {
//       //console.log("click END", selectedHotspot)
//       if (clickTime === undefined || Date.now() - clickTime < 150) return;

//       if (selectedHotspot !== undefined) {
//         const invertedPoint = inverseTransform.point2d({ x: snapPosition?.x ?? 0, y: snapPosition?.y ?? 0 })
//         const updatedPoints = polygonPoints.map(
//           (p, i) => {
//             return selectedHotspot && i === parseInt(selectedHotspot.id)
//               ? { ...p, ...invertedPoint }
//               : p
//           })
//         dispatch(
//           replaceShape(recalculateShape({
//             ...shapeProps,
//             points: updatedPoints,
//           }))
//         );
//         setPolygonPoints(polygonPoints.map(
//           point => point.id === selectedHotspot.id ? { ...point, isDragging: false } : point
//         ))
//         dispatch(interactionAddEditingReferencePoint(undefined))
//         setSelectedHotspot(undefined);
//       }
//     },
//     move: (e: MouseEvent) => {
//       if (selectedHotspot === undefined) {
//         return;
//       } else {
//         const invertedPoint = inverseTransform.point2d({ x: snapPosition?.x ?? 0, y: snapPosition?.y ?? 0 })
//         const points = trafoedHSPointslocal.map(
//           (coordiante, i) => {
//             const c = (
//               selectedHotspot && i === parseInt(selectedHotspot.id)
//                 ? ({ ...coordiante, ...invertedPoint })
//                 : coordiante);
//             return { ...coordiante, ...c };
//           }
//         )
//         setPolygonPoints(points)
//       }
//     },
//   }

  //const currentMouseClickInteraction = mouseClickMovePointInteraction;
  const hotspotInteract: MouseInteraction = {
    handleDragStart: handleHotspotDragStart,
    handleDragMove: handleHotspotDragMove,
    handleDragEnd: handleHotspotDragEnd,
    // handleClick: currentMouseClickInteraction.clickStart,
    // handleClickEnd: currentMouseClickInteraction.clickEnd,
    // handleClickMove: currentMouseClickInteraction.move,
  };

//   const setRef = (ref: Konva.Line | undefined) => {
//     if (ref) konvaLineRef.current = ref;
//   }

  return (
    <>
      <BasePolygon
        // setRef={setRef}
        shapeProps={{
            ...shapeProps,
            points: polygonPoints,
            transformation: shapeTransformer.m,
        }}
        onClick={onSelect}
      // interaction={currentMouseInteraction}
      />
      {selected &&
        trafoedHSPoints.map((hotspot, index) => (
        <ClickableHotspot
            key={`${hotspot.id}-hotspot-${index}`}
            shapeProps={hotspot}
            interaction={currentTool === 'select' ? hotspotInteract : undefined}
      />
      ))}
    </>
  );
}
const createPolygon = (
    shapeProps: GeometricShape,
    onSelect: (e: KonvaEventObject<MouseEvent>) => void
) => {
    if (shapeProps.type === "polygon") {
        return (
            <Polygon
                key={shapeProps.id}
                shapeProps={shapeProps}
                onSelect={onSelect}
            />
        );
    }
    throw Error("not a polygon in place of polygon")
};

function chooseNearestPoint(leftPoint: Point2d, rightPoint: Point2d, referencePoint: Point2d): Point2d {
  if (!leftPoint) return rightPoint;
  if (!rightPoint) return leftPoint;
  const distLeft = distance2d(leftPoint, referencePoint);
  const distRight = distance2d(rightPoint, referencePoint);
  return (distLeft - distRight) > 0 ? rightPoint : leftPoint
}

function globalPolygon(s: GeometricShape) {
  const tr = new Transform(s.transformation);

  const transformed = {
    ...s,
    // dash: d.find((i) => i.id === (s as LineShape).dashID)?.dash,
    points: (s as PolygonShape).points.map((point) => {
      return tr.point2d(point);
    }),
    boundingboxPosition: tr.getTranslation()
  };
  const { transformation, ...remainingShape } = transformed;
  return remainingShape;
}

export function calculatePolygonSnapPoints(l: GeometricShape): GeometricShape {
  const trans = new Transform(l.transformation);
  return {
    ...l,
    snapPoint: (l as PolygonShape).points.map((p) => trans.point2d(p)),
  };
}

function convertToPolyline(shape: GeometricShape): LineShape {
  if (shape.type === "polygon") {
    console.log("converting");
    const line: LineShape = {
      ...shape as unknown as LineShape,
    //   fill: "rgb(55,55,55)",
    //   fillEnabled: true,
       type: "polyline",
    //   points: shape.points[0] === shape.points[shape.points.length - 1] ? shape.points : [...shape.points, shape.points[0]],
    //   closed: true
    };
    console.log(line);
    return line;
  }
  throw Error("shape is not covertable to polygon")
}

function deletePoint(
  hs: Hotspot[],
  id: number,
  position: Point2d,
  scale: number
): Hotspot[] {
  //TODO Would be enough to compare the neighbouring points...
  const nearPoint = hs.find(
    (h, i) =>
      (i === id + 1 || i === id - 1) &&
      Math.abs(position.x - h.x) < (40 * 1) / scale &&
      Math.abs(position.y - h.y) < (40 * 1) / scale
  );
  if (nearPoint) {
    const reducedList = hs.slice(0, id).concat(hs.slice(id + 1, hs.length));
    return reducedList;
  }
  return hs;
}

function polygonBoundingboxCalculation(l: GeometricShape) {
  if (l.type === "polygon") {
    const trans = new Transform(l.transformation)
    const xPositions = l.points.map((point) => trans.point2d(point).x)
    const yPositions = l.points.map((point) => trans.point2d(point).y)
    const minX = Math.min(...xPositions)
    const maxX = Math.max(...xPositions)
    const minY = Math.min(...yPositions)
    const maxY = Math.max(...yPositions)
    //console.log({ width: maxX - minX, height: maxY - minY });

    return {
      width: maxX - minX, height: maxY - minY,
      boundingboxPosition: { x: minX, y: minY }
    }
  } else {
    throw new Error("Not a polygon boundingbox");
  }

}

function transformPolygonToInternalShape(s: JSONGeometricShape): GeometricShape {
  if (s.type === "polygon") {
    const xMin = Math.min(...s.points.map((point) => point.x))
    const yMin = Math.min(...s.points.map((point) => point.y))
    s.points = s.points.map((point) => { return { x: point.x - xMin, y: point.y - yMin } })
    const translatedShape = transformShape(s, Transform.translationTransform(xMin, yMin)) as PolygonShape
    return translatedShape;
  }
  return s;
}

function polygonIntersectWithRect(l: GeometricShape, r: RectSel) {
  const trans = new Transform(l.transformation);
  const pointsAbsolutePosition = (l as PolygonShape).points.map((p) =>
    trans.point2d(p)
  );
  const segments = pointsAbsolutePosition
    .map((p, i, a) => {
      if (i > 0) {
        return { start: a[i - 1], end: p }
      }
      else {
        return undefined;
      };
    })
    .filter((i) => i !== undefined) as { start: Point2d; end: Point2d }[];
  return lineRectIntersection(segments, r);
}

// function splitByLine(shape: GeometricShape, line: Segment): GeometricShape[] {
//   const lineShape = shape as LineShape;
//   const inverseTransform = new Transform(shape.transformation).invert2d();
//   const transformedSectionline: Segment = [inverseTransform.point2d(line[0]), inverseTransform.point2d(line[1])];
//   const segments = makeSegmentsFromPoints(lineShape.points)
//   const intersections = getIntersectionPoint(segments, transformedSectionline)

//   if (intersections.length) {
//     let currentLinePointsToCutFrom = lineShape.points;
//     const shapesAfterSpliting = intersections.map((intersection, i, array) => {
//       const indexDifferenc = intersection.index - (i === 0 ? 0 : array[i - 1].index);
//       const newPoints = currentLinePointsToCutFrom
//         .slice(undefined, indexDifferenc + 1)
//         .concat(intersection.point);

//       currentLinePointsToCutFrom = [intersection.point, ...currentLinePointsToCutFrom.slice(indexDifferenc + 1)];
//       return recalculateShape({ ...lineShape, points: newPoints });
//     })

//     const endOfLineChain = recalculateShape({
//       ...lineShape,
//       points: currentLinePointsToCutFrom
//     })
//     return shapesAfterSpliting.concat(endOfLineChain);
//   }
//   return [];
// }

// function getIntersectionPoint(segments: Segment[], line: Segment) {
//   const intersections = segments.map(
//     (segment, index) =>
//       segmentSegmentIntersection(...segment, ...line)
//         ? { index, point: lineLineIntersectionFromSegments(segment, line) }
//         : null
//   )
//   const filteredIntersections = intersections.filter(x => x !== null)
//   return filteredIntersections;
// }

export {
    createPolygon,
    createPolygonRubber,
    polygonIntersectWithRect,
    globalPolygon,
    polygonBoundingboxCalculation,
    transformPolygonToInternalShape,
    convertToPolyline,
}
export default Polygon;